<template>
    <vs-pagination 
    :total="pageCount" v-model="meta.current_page"
     @change="handlePageChange(meta.current_page)"
    ></vs-pagination>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    meta: {
      type: Object,
      required: false,
      default: () => {
        return {
          current_page: 1,
          has_next: true,
          limit: 20,
          next_page_url: '',
          previous_page_url: null,
          total: 0
        }
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    pageCount () {
      const _temp = Math.ceil(this.meta.total / this.meta.limit)
      return _temp
    }
  },
  methods: {
    handlePageChange (page) {
      console.log(page)
      this.$emit('page-change', page)
    }
  }
}
</script>
